import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import UXDesigns from "./pages/UXDesigns";
import LogoGallery from "./pages/LogoGallery";
import FlyerGallery from "./pages/FlyerGallery";
import MobileAppGallery from "./pages/MobileAppGallery";
import WebDevelopment from "./pages/WebDevelopment";
import LogoDesignServices from "./pages/LogoDesignServices";
import FlyerDesignServices from "./pages/FlyerDesignServices";
import MobileAppDevelopmentServices from "./pages/MobileAppDevelopmentServices";
import UXDesignServices from "./pages/UXDesignServices";
import LogoDesignGuide from "./pages/LogoDesignGuide";
import WhatMakesGoodLogo from "./pages/WhatMakesGoodLogo";
import LogoDesignPrinciples from "./pages/LogoDesignPrinciples";
import TypesOfLogosExplained from "./pages/TypesOfLogosExplained";
import MinimalistLogoDesignGuide from "./pages/MinimalistLogoDesignGuide";
import HowToDesignLogo from "./pages/HowToDesignLogo";
import LogoDesignToolsComparison from "./pages/LogoDesignToolsComparison";
import Navigation from "./components/Navigation";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <div className="dark min-h-screen">
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Navigation />
            <main className="pt-16">
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/ux-designs" element={<UXDesigns />} />
                <Route path="/logo-designs" element={<LogoGallery />} />
                <Route path="/flyer-designs" element={<FlyerGallery />} />
                <Route path="/mobile-app-designs" element={<MobileAppGallery />} />
                <Route path="/web-development" element={<WebDevelopment />} />
                <Route path="/services/logo-design" element={<LogoDesignServices />} />
                <Route path="/services/flyer-design" element={<FlyerDesignServices />} />
                <Route path="/services/mobile-app-development" element={<MobileAppDevelopmentServices />} />
                <Route path="/services/ui-ux-design" element={<UXDesignServices />} />
                <Route path="/logo-design-services-guide" element={<LogoDesignGuide />} />
                <Route path="/what-makes-a-good-logo" element={<WhatMakesGoodLogo />} />
                <Route path="/logo-design-principles" element={<LogoDesignPrinciples />} />
                <Route path="/types-of-logos-explained" element={<TypesOfLogosExplained />} />
                <Route path="/minimalist-logo-design-guide" element={<MinimalistLogoDesignGuide />} />
                <Route path="/how-to-design-a-logo" element={<HowToDesignLogo />} />
                <Route path="/logo-design-tools-comparison" element={<LogoDesignToolsComparison />} />
              </Routes>
            </main>
          </BrowserRouter>
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;